export type SearchVerticalSlug =
  | "everything-equine"
  | "horses"
  | "saddlery-tack-apparel"
  | "transport-vehicles"
  | "stallions-at-stud"
  | "equine-property"
  | "services"
  | "products-equipment";

export interface SearchVerticalOption {
  id: string;
  label: string;
  slug: SearchVerticalSlug;
  level: number;
  isHorses?: boolean;
  hideFromTopNav?: boolean;
}

const VERTICAL_OPTIONS: SearchVerticalOption[] = [
  {
    id: "0",
    label: "Everything Equine",
    slug: "everything-equine",
    level: 0,
    isHorses: true,
    hideFromTopNav: true,
  },
  {
    id: "196",
    label: "Horses",
    slug: "horses",
    level: 0,
    isHorses: true,
  },
  {
    id: "201",
    label: "Transport & Vehicles",
    slug: "transport-vehicles",
    level: 0,
  },
  {
    id: "198",
    label: "Saddlery, Tack & Apparel",
    slug: "saddlery-tack-apparel",
    level: 0,
  },
  {
    id: "202",
    label: "Equine Property",
    slug: "equine-property",
    level: 0,
  },
  {
    id: "197",
    label: "Stallions at Stud",
    slug: "stallions-at-stud",
    isHorses: true,
    level: 0,
  },
  {
    id: "204|375|199",
    label: "Products & Equipment",
    slug: "products-equipment",
    level: 0,
  },
  {
    id: "services",
    label: "Services",
    slug: "services",
    level: 0,
  },
];

export default VERTICAL_OPTIONS;
